import { memo } from "react";

import Valkyrie, { viPlus, viSpinnerThird } from "@sippy-platform/valkyrie";

import { Card, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddCard({ onClick, id, title, subtitle, disabled = false, loading = false }) {
  return (
    <Card variant="outlined">
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={onClick} id={id} disabled={disabled || loading} sx={{ borderRadius: 0 }}>
            <ListItemAvatar sx={{ display: "flex", alignItems: "center", pl: 1 }}>
              <Valkyrie icon={loading ? viSpinnerThird : viPlus} spin={loading} />
            </ListItemAvatar>
            <ListItemText primary={title} secondary={subtitle} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

AddCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default memo(AddCard);
